import Head from 'next/head';
import { useRouter } from 'next/router';

const BASE_URL = 'https://cphsecuritywait.dk';

// Site-wide entity graph, server-rendered on every page for entity
// comprehension and knowledge-graph grounding (research log R2.3).
//
// Deliberately NO `potentialAction`/`SearchAction`: Google retired the
// Sitelinks Search Box in Nov 2024, so that markup is dead (research log R2.1).
//
// `sameAs` is where verified entity references go (e.g. a Wikidata item, social
// profiles) once they exist - add them here to strengthen the knowledge-graph
// link. Left empty until those exist rather than inventing URLs.
const SAME_AS = [];

export default function SiteJsonLd() {
    const router = useRouter();
    const locale = router.locale === 'en' ? 'en' : 'da';

    const graph = {
        '@context': 'https://schema.org',
        '@graph': [
            {
                '@type': 'WebSite',
                '@id': `${BASE_URL}/#website`,
                url: `${BASE_URL}/`,
                name: 'CPH Security Wait',
                inLanguage: locale,
                publisher: { '@id': `${BASE_URL}/#organization` },
                about: { '@id': `${BASE_URL}/#airport` }
            },
            {
                '@type': 'Organization',
                '@id': `${BASE_URL}/#organization`,
                name: 'CPH Security Wait',
                url: `${BASE_URL}/`,
                description:
                    'Independent live tracker for security wait times, delayed flights, passport control times and parking availability at Copenhagen Airport (CPH).',
                knowsAbout: { '@id': `${BASE_URL}/#airport` },
                ...(SAME_AS.length ? { sameAs: SAME_AS } : {})
            },
            {
                // The real-world entity this site reports on (not the publisher).
                '@type': 'Airport',
                '@id': `${BASE_URL}/#airport`,
                name: 'Copenhagen Airport',
                alternateName: 'Københavns Lufthavn, Kastrup',
                iataCode: 'CPH',
                icaoCode: 'EKCH',
                url: 'https://www.cph.dk',
                address: {
                    '@type': 'PostalAddress',
                    addressLocality: 'Kastrup',
                    addressRegion: 'Hovedstaden',
                    postalCode: '2770',
                    addressCountry: 'DK'
                }
            }
        ]
    };

    return (
        <Head>
            <script
                type="application/ld+json"
                // schema content is static/trusted; escape < to avoid any HTML break-out
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(graph).replace(/</g, '\\u003c')
                }}
            />
        </Head>
    );
}
